import { render, staticRenderFns } from "./AddCalendarItemPage.vue?vue&type=template&id=3284d59a&scoped=true&"
import script from "./AddCalendarItemPage.vue?vue&type=script&lang=js&"
export * from "./AddCalendarItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284d59a",
  null
  
)

export default component.exports